import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import * as Styles from './Process.module.scss';
export function RenderProcess(component, index) {
    return (_jsx(ProcessComponent, { id: component.properties.id }, index));
}
export class ActivityState {
    static Pending = "Pending";
    static InProgress = "InProgress";
    static Completed = "Completed";
    static Failed = "Failed";
    static Cancelled = "Cancelled";
}
export function ProcessComponent(props) {
    var context = Common.useSpaContext();
    var processes = context?.process;
    if (props.id == "debug1") {
        return _jsx(ProcessDisplay, { process: debugProcess1 });
    }
    if (props.id == null || !processes || !processes[props.id]) {
        return _jsx("div", { children: "Process not found" });
    }
    var processInfo = JSON.parse(processes[props.id]);
    if (!processInfo) {
        return _jsx("div", { children: "Process not found" });
    }
    return _jsx(ProcessDisplay, { process: processInfo });
}
export function ProcessDisplay(props) {
    return (_jsx("ul", { className: Styles.process, children: props.process.tasks.map((activity, index) => (_jsx(Activity, { activity: activity }, index))) }));
}
export function Activity(props) {
    var classes = Utils.classNames({
        [Styles.activity]: true,
        [Styles.pending]: props.activity.state === ActivityState.Pending,
        [Styles.running]: props.activity.state === ActivityState.InProgress,
        [Styles.completed]: props.activity.state === ActivityState.Completed,
        [Styles.cancelled]: props.activity.state === ActivityState.Cancelled,
        [Styles.failed]: props.activity.state === ActivityState.Failed,
    });
    if (!props.activity.name || props.activity.name === "hidden") {
        return null;
    }
    var progress = _jsx(_Fragment, {});
    if (props.activity.state === ActivityState.InProgress) {
        if (props.activity.progress != null) {
            progress = (_jsxs(_Fragment, { children: [_jsx(Components.Progress, { value: props.activity.progress, max: 100, size: Components.ProgressSize.Small }), _jsx("small", { children: props.activity.progressString })] }));
        }
        else if (props.activity.progressString) {
            progress = _jsx("small", { children: props.activity.progressString });
        }
    }
    return (_jsxs("li", { className: classes, children: [_jsx("span", { className: Styles.activityState, children: props.activity.state }), _jsx("span", { className: Styles.activityName, children: props.activity.name }), _jsx("span", { className: Styles.activityProgress, children: progress })] }));
}
var debugProcess1 = {
    id: "debug1",
    name: "Debug Process",
    isRunning: true,
    started: new Date(),
    finished: new Date(),
    tasks: [
        {
            id: "activity1",
            name: "Activity 1",
            state: ActivityState.Completed,
            started: new Date(),
            finished: new Date(),
            progress: 100,
            progressString: null
        },
        {
            id: "activity2",
            name: "Activity 2",
            state: ActivityState.InProgress,
            started: new Date(),
            finished: null,
            progress: 50,
            progressString: "0:35"
        },
        {
            id: "activity21",
            name: "Activity 21",
            state: ActivityState.InProgress,
            started: new Date(),
            finished: null,
            progress: null,
            progressString: "doing something..."
        },
        {
            id: "activity3",
            name: "Activity 3",
            state: ActivityState.Pending,
            started: null,
            finished: null,
            progress: 0,
            progressString: null
        },
        {
            id: "activity4",
            name: "Activity 4",
            state: ActivityState.Cancelled,
            started: null,
            finished: null,
            progress: 0,
            progressString: null
        },
        {
            id: "activity5",
            name: "Activity 5",
            state: ActivityState.Failed,
            started: null,
            finished: null,
            progress: 0,
            progressString: null
        }
    ]
};
